import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useAppVersion } from '../hooks/useAppVersion';

const DEV_SUFFIX = '-dev';
const SHORT_SHA_LENGTH = 7;

export function AppVersionSection() {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const { systemVersion, isLoading, error } = useAppVersion();

    const version = systemVersion?.version;
    const showSha = Boolean(
        version?.endsWith(DEV_SUFFIX) && systemVersion?.sha,
    );

    return (
        <div className="flex flex-col gap-4">
            <h3 className="text-sm font-medium text-white-100">
                {t('version.title')}
            </h3>
            <div className="flex flex-col gap-1 pl-2">
                <span className="text-sm text-grey-200 tracking-wide">
                    {t('version.label')}
                </span>
                {isLoading ? (
                    <div className="h-5 w-24 rounded bg-grey-600 animate-pulse" />
                ) : (
                    <span className="text-sm text-white-100">
                        {error || !version ? (
                            <span className="text-grey-400">
                                {t('version.unavailable')}
                            </span>
                        ) : (
                            <>
                                {`v${version}`}
                                {showSha && (
                                    <span className="text-grey-300">
                                        {` (${systemVersion?.sha?.slice(0, SHORT_SHA_LENGTH)})`}
                                    </span>
                                )}
                            </>
                        )}
                    </span>
                )}
            </div>
        </div>
    );
}
